import { createEventHandlers } from '@play-co/replicant';
import { stateSchema } from '../../State';
import messages from '../messages';
import scheduledActions from '../scheduledActions';
import computedProperties from '../computedProperties';
import asyncGetters from '../asyncGetters';
import actions from '../actions';
import ab from 'src/replicant/ruleset/ab';
import chatbot from 'src/replicant/chatbot';

const config = {
  stateSchema,
  ruleset: { abTests: ab.dynamicAB },
  messages,
  asyncGetters,
  scheduledActions,
  computedProperties,
  actions,
  chatbot,
};

export default createEventHandlers(stateSchema, config);
